import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";

@Component({
    selector: 'app-disclaimer-popup',
    templateUrl: './disclaimer-popup.component.html',
    styleUrls: ['./disclaimer-popup.component.scss'],
    standalone: false
})
export class DisclaimerPopupComponent implements OnInit {
   isAccepted = true;
   isVisible = false;

   private readonly STORAGE_KEY = 'disclaimerAccepted';
   private readonly COUNTRY_KEY = 'userCountryCode';
   private readonly OPEN_DELAY = 1000;

   private readonly EXCLUDED_ROUTES = [
      '/halal-trading-waitlist',
      '/supported-countries',
      '/supported-brokerages',
      '/investing-coverage'
   ];

   private readonly isBrowser: boolean;

   constructor(
      @Inject(PLATFORM_ID) platformId: Object,
      private apiService: ApiService,
      private router: Router
   ) {
      this.isBrowser = isPlatformBrowser(platformId);
   }

   async ngOnInit(): Promise<void> {
      if (!this.isBrowser) return;

      if (this.isExcludedRoute()) return;
      if (localStorage.getItem(this.STORAGE_KEY) === 'true') return;

      const country = await this.getCountryCode();
      if (country !== 'IN') return;

      setTimeout(() => {
         // 🔒 Final safety check (simple & sufficient)
         if (!this.isExcludedRoute()) {
            this.isVisible = true;
         }
      }, this.OPEN_DELAY);
   }

   private isExcludedRoute(): boolean {
      return this.EXCLUDED_ROUTES.some(p =>
         this.router.url.startsWith(p)
      );
   }

   private async getCountryCode(): Promise<string> {
      const cached = localStorage.getItem(this.COUNTRY_KEY);
      if (cached) return cached;

      try {
         const res = await this.apiService.getUserCountryCode();
         const code = res?.data?.iso_code ?? 'UNKNOWN';
         localStorage.setItem(this.COUNTRY_KEY, code);
         return code;
      } catch {
         localStorage.setItem(this.COUNTRY_KEY, 'UNKNOWN');
         return 'UNKNOWN';
      }
   }

   accept(): void {
      if (!this.isBrowser) return;

      localStorage.setItem(this.STORAGE_KEY, 'true');
      this.isVisible = false;
   }
}